
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#2F80ED","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.368 0 0 5.367 0 12c0 2.105.549 4.16 1.591 5.974L.045 22.775a.937.937 0 001.18 1.18l4.801-1.546A11.973 11.973 0 0012 24c6.632 0 12-5.367 12-12 0-6.632-5.367-12-12-12zm0 22.125c-1.901 0-3.754-.53-5.36-1.534a.939.939 0 00-.784-.098L2.39 21.61l1.116-3.466a.938.938 0 00-.097-.785A10.097 10.097 0 011.875 12C1.875 6.417 6.417 1.875 12 1.875S22.125 6.417 22.125 12 17.583 22.125 12 22.125zM13.172 12a1.172 1.172 0 11-2.344 0 1.172 1.172 0 012.344 0zm4.687 0a1.172 1.172 0 11-2.343 0 1.172 1.172 0 012.343 0zm-9.375 0a1.172 1.172 0 11-2.343 0 1.172 1.172 0 012.343 0z"}})])
          )
        }
      }
    